import {Box} from "@mui/material";
import styles from "./style.module.css";

export function LegacyLogoVCloud({focused, ...props}: any) {
    return (
        <Box position="relative" {...props}>
            <Box position="absolute" zIndex={1} className={styles[focused ? "rotateForward" : "rotateBackward"]}>
                <svg width="47.39" height="45.4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42.39 40.4">
                    <path className="cls-1" fill={focused ? "#dcdcdc" : "#f5f5f7"}
                          d="M23.82,12.3c-1.88-1.62-4.4-2.35-6.92-2.01-2.58.35-4.87,1.78-6.28,3.89-1.76,2.49-1.68,5.3-1.6,8.01.01.45.03.9.03,1.35,0,.46.38.83.84.83h2.07c.46,0,.84-.37.85-.82.01-.54,0-1.1-.01-1.66-.04-1.89-.09-3.85.78-5.37.74-1.24,1.98-2.14,3.4-2.45,1.45-.31,2.91-.03,4.12.81,2.54,1.72,2.45,4.44,2.35,7.33-.01.44-.03.87-.03,1.31,0,.46.36.84.82.85.52.01,1.33.05,1.83.08.02,0,.03,0,.05,0,.24,0,.47-.09.64-.25.19-.18.3-.42.31-.68l.02-.52c.12-3.97.23-7.73-3.27-10.71Z"/>

                </svg>
            </Box>
            <svg width="47.39" height="45.4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42.39 40.4">
                <g>
                    <path className="cls-4" fill="#d1d1d3"
                          d="M35.94,11.53c-.23-.58-.73-1.53-.73-1.53-1.57-2.26-4.23-3.05-6.88-3.05C23.7-2,8.56-.52,7.38,10.1,3.68,10.97.75,13.49.02,17.37c.28-4.37,3.05-7.04,7.24-8.27C8.54-1.58,23.64-3.18,28.16,6.01c3.69-.19,7.2,1.74,7.78,5.53Z"/>
                    <path className="cls-4" fill="#d1d1d3"
                          d="M42.36,20.02v.12c-.68-2.13-1.96-3.76-4.19-4.45-1-.3-1.88-.36-2.27-.39,0,0,.09-.25.22-.98,0-.02.01-.03.01-.05,2.97.46,5.92,2.59,6.23,5.75Z"/>
                    <path className="cls-2" fill={focused ? "#f5f5f7" : "#dcdcdc"}
                          d="M42.36,20.15c-.68-2.13-1.96-3.76-4.19-4.45-1-.3-1.88-.36-2.27-.39,0,0,.09-.25.22-.98,0-.02.01-.03.01-.05.02-.1.04-.21.06-.35.1-.58-.02-1.56-.16-2.13-.02-.07-.05-.16-.09-.26h0c-.22-.59-.73-1.54-.73-1.54-1.57-2.27-4.23-3.06-6.88-3.06C23.7-2,8.56-.53,7.37,10.1,3.68,10.98.75,13.49.02,17.36c-.01.03-.01.07-.02.11,0,.11,0,.24.01.34v.2c.05,1.87.41,3.24,1.76,4.87,1.72,2.43,4.86,3.78,7.95,3.83l24.29.11c1.99.04,3.85.09,5.71-1.09,1.78-1.18,2.46-2.64,2.62-4.53.01-.04.01-.09.01-.13.01-.13.02-.27.02-.4h0v-.02c.01-.13.01-.29.01-.43-.01-.03-.02-.05-.03-.08Z"/>
                </g>
                <path className="cls-3" fill="#ee4d2f"
                      d="M25.72,22.84h-14.85c-2.5,0-4.52,2.03-4.52,4.52v8.52c0,2.5,2.03,4.52,4.52,4.52h14.85c2.5,0,4.52-2.03,4.52-4.52v-8.52c0-2.5-2.03-4.52-4.52-4.52ZM20.07,35.5h-3.55l.34-3.71c-.51-.42-.84-1.04-.84-1.75,0-1.26,1.02-2.28,2.28-2.28s2.28,1.02,2.28,2.28c0,.71-.33,1.34-.84,1.75l.34,3.71Z"/>
            </svg>
        </Box>
    )
}

export function OriginalLogoVCloud({width = 50, height = 24}: { width?: number, height?: number }) {
    return (
        <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
             viewBox="0 0 41.55 24.8">
            <defs>
                <linearGradient id="linear-gradient" x1="-22.19" y1="-18.22" x2="22.88" y2="26.85"
                                gradientTransform="translate(0 25.02) scale(1 -1)"
                                gradientUnits="userSpaceOnUse">
                    <stop offset=".29" stopColor="#fafe56"/>
                    <stop offset=".35" stopColor="#f2fa5c"/>
                    <stop offset=".44" stopColor="#dcf06f"/>
                    <stop offset=".55" stopColor="#bae08e"/>
                    <stop offset=".68" stopColor="#89c9b8"/>
                    <stop offset=".82" stopColor="#4faeec"/>
                </linearGradient>
                <linearGradient id="linear-gradient-2" x1="-11.96" y1="-25.79" x2="46.37" y2="30.88"
                                xlinkHref="#linear-gradient"/>
            </defs>
            <g className="cls-1">
                <path className="cls-3" fill="url(#linear-gradient)" strokeWidth="0"
                      d="M16.68,6.2l-3.61,5.94-7.51,12.66L0,15.3,5.55,6.2h11.13Z"/>
                <path className="cls-4" fill="url(#linear-gradient-2)" strokeWidth="0"
                      d="M34.49,0h-14.04l-3.77,6.2-3.61,5.94-7.51,12.66h29.15l6.85-12.66L34.49,0Z"/>
            </g>
        </svg>
    )
}

export default function InternalOpennebula({focused, width, height, ...props}: any) {
    return (
        <Box position="relative" display="flex" alignContent="center" {...props}>
            <Box my="auto" sx={{scale: focused ? '120%' : '100%', transition: 'scale linear 0.15s'}}>
                <OriginalLogoVCloud width={width} height={height}/>
            </Box>
        </Box>
    )
}